import {APP_SETTINGS_PREFIX} from "./preferences_slice.js";
import {selectPreference} from "./select_preference.js";

export const selectAppSetting = k => selectPreference([`${APP_SETTINGS_PREFIX}.${k}`]);
